import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { Instagram, Play } from "lucide-react";

export default function InstagramSection() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    axios.get(`${API}/instagram-posts`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);
  if (!posts.length) return null;
  return (
    <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-24" data-testid="instagram-section">
      <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
        <div>
          <div className="font-micro text-[#B8895C] mb-3 flex items-center gap-2">
            <Instagram size={14} strokeWidth={1.5} /> @theteakstudio_
          </div>
          <h2 className="font-serif text-[#EDE4D3] text-4xl md:text-5xl">From the studio floor.</h2>
        </div>
        <a
          href="https://www.instagram.com/theteakstudio_/"
          target="_blank"
          rel="noreferrer"
          className="btn-ghost"
          data-testid="instagram-follow-btn"
        >
          Follow on Instagram
        </a>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {posts.slice(0, 8).map((p, i) => (
          <a
            key={p.id || i}
            href={p.permalink}
            target="_blank"
            rel="noreferrer"
            className="img-cinematic aspect-square relative group"
            data-testid={`instagram-tile-${i}`}
            style={{ background: "#141414" }}
          >
            <img src={p.thumbnail} alt={p.caption || ""} className="w-full h-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-700 flex items-center justify-center">
              {p.is_reel && (
                <div className="absolute top-3 right-3 text-[#EDE4D3]">
                  <Play size={16} strokeWidth={1.5} fill="currentColor" />
                </div>
              )}
              <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-700 font-micro text-[#EDE4D3] px-4 text-center">
                View on Instagram →
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
